import * as React from 'react';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Image from 'mui-image';
import Link from '@mui/material/Link';
import { Link as RouterLink } from "react-router-dom"

import PageContainer from './PageContainer';

import coverImage from './images/mirri.jpg';
import kissatImg from './images/kissat.jpg';
import meistaImg from './images/meista.jpg';
import menuImg from './images/menu.jpg';
import yhteystiedotImg from './images/yhteystiedot.jpg';




function PageHome() {
	let linksGridSize = {
		xs: 12,
		sm: 6,
		md: 3
	};
	return (
	<PageContainer header='Tervetuloa Turun kissakahvilaan!' header_variant='h3' header_image={coverImage}>
		<Typography variant='h5' sx={{ textAlign:'center' }}>
			Kissakahvila Mirri on enemmän kuin kahvila – se on paikka kohtaamisille, rauhoittumiselle ja lempeille hetkille kissojen seurassa.
			Herkulliset leivonnaiset, kiireetön tunnelma ja yhteys eläimiin kutsuvat viihtymään.
			Haluamme rakentaa yhteisön, jossa jokainen saa olla oma itsensä – niin ihminen kuin kissa. Astu sisään ja tunne, miten arki kevenee.
		</Typography>
		<Grid container spacing={2}>
			<Grid size={linksGridSize}>
				<Box sx={{ minHeight: '4rem', display:'flex', alignItems:'flex-end', justifyContent: 'center' }}>
					<Link component={RouterLink} to="/kissat" variant='h6' sx={{ fontWeight: 'bold', textAlign: 'center' }}>KISSAT</Link>
				</Box>
				<RouterLink to="/kissat">
					<Image sx={{pb:"3rem", objectFit:'cover'}} src={kissatImg} height={300} />
				</RouterLink>
			</Grid>
			<Grid size={linksGridSize}>
				<Box sx={{ minHeight: '4rem', display:'flex', alignItems:'flex-end', justifyContent: 'center' }}>
					<Link component={RouterLink} to="/meista" variant='h6' sx={{ fontWeight: 'bold', textAlign: 'center' }}>MEISTÄ</Link>
				</Box>
				<RouterLink to="/meista">
					<Image sx={{pb:"3rem", objectFit:'cover'}} src={meistaImg} height={300} />
				</RouterLink>
			</Grid>
			<Grid size={linksGridSize}>
				<Box sx={{ minHeight: '4rem', display:'flex', alignItems:'flex-end', justifyContent: 'center' }}>
					<Link component={RouterLink} to="/menu" variant='h6' sx={{ fontWeight: 'bold', textAlign: 'center' }}>MENU</Link>
				</Box>
				<RouterLink to="/menu">
					<Image sx={{pb:"3rem", objectFit:'cover'}} src={menuImg} height={300} />
				</RouterLink>
			</Grid>
			<Grid size={linksGridSize}>
				<Box sx={{ minHeight: '4rem', display:'flex', alignItems:'flex-end', justifyContent: 'center' }}>
					<Link component={RouterLink} to="/yhteystiedot" variant='h6' sx={{ fontWeight: 'bold', textAlign: 'center' }}>SIJAINTI JA YHTEYSTIEDOT</Link>
				</Box>
				<RouterLink to="/yhteystiedot">
					<Image sx={{pb:"3rem", objectFit:'cover'}} src={yhteystiedotImg} height={300} />
				</RouterLink>
			</Grid>
		</Grid>
	</PageContainer>
    );
}

export default PageHome;